<template>
  <!-- <div class="sidebar-footer"></div> -->
</template>
<script>
export default {
  name: "SidebarFooter"
};
</script>
